var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H22M3.77 10.77L2 9L4 4.5L5.1 5.05C5.65 5.33 6 5.89 6 6.5C6 7.11 6.35 7.67 6.9 7.95L8 8.5L11 2.5L12.05 3.03C12.3418 3.17534 12.5937 3.38981 12.7836 3.65473C12.9736 3.91965 13.096 4.22699 13.14 4.55L13.86 9.95C13.904 10.273 14.0264 10.5804 14.2164 10.8453C14.4063 11.1102 14.6582 11.3247 14.95 11.47L19.35 13.67C19.77 13.89 20.13 14.22 20.36 14.63L20.96 15.66C21.45 16.54 20.9 17.64 19.9 17.76L18.72 17.91C18.25 17.97 17.77 17.89 17.35 17.67L4.29 11.15C4.09728 11.0523 3.92167 10.9239 3.77 10.77Z",
    stroke: "#101010",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneIcon);
export default __webpack_public_path__ + "static/media/plane-icon.636242126741e4c7b39b04e5f0643ef0.svg";
export { ForwardRef as ReactComponent };